<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">
      {{ $t("loan module settings") }}
    </div>

    <div class="box">
      <div class="columns mt-5">
        <div class="column">
          <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_integrate_drive_product"
              name="chk_integrate_drive"
              v-model="meta.integrate_drive"
            />
            <label for="chk_integrate_drive_product">{{
              $t("integrate")
            }}</label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('application files drive')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/drive/catalog"
              name_field="name"
              value_field="drive_id"
              @selected="drive_changed"
              ref="drive_dropdown"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "LoanSettings",
  components: {
    GenericDropdown,
  },
  data() {
    return {
      meta: {
        integrate_drive: false,
        application_files_drive_id: null,
      },
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("settings saved successfully"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    drive_changed(selected) {
      if (selected) this.meta.application_files_drive_id = selected.drive_id;
      else this.meta.application_files_drive_id = null;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;

          if (conf.application_files_drive_id) {
            v.$refs.drive_dropdown.set_value(conf.application_files_drive_id);
          }
        }
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>
